const initReferenceLightbox = () => {
	const referenceLinks = Array.from(document.querySelectorAll('.references-section__card[data-lightbox="mapro-references"]'));

	if (!referenceLinks.length) {
		return;
	}

	let activeTrigger = null;
	let activeIndex = 0;
	let touchStartX = 0;
	let touchStartY = 0;
	let canSwipe = false;
	const backgroundStates = new Map();

	const lightbox = document.createElement('div');
	lightbox.className = 'reference-lightbox';
	lightbox.setAttribute('role', 'dialog');
	lightbox.setAttribute('aria-modal', 'true');
	lightbox.setAttribute('aria-label', 'Podgląd dokumentów referencyjnych');
	lightbox.setAttribute('aria-hidden', 'true');

	const makeIcon = (path) => {
		const icon = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
		icon.setAttribute('viewBox', '0 0 24 24');
		icon.setAttribute('aria-hidden', 'true');
		icon.setAttribute('focusable', 'false');
		const line = document.createElementNS('http://www.w3.org/2000/svg', 'path');
		line.setAttribute('d', path);
		icon.appendChild(line);
		return icon;
	};

	const closeButton = document.createElement('button');
	closeButton.className = 'reference-lightbox__close';
	closeButton.type = 'button';
	closeButton.setAttribute('aria-label', 'Zamknij podgląd referencji');
	closeButton.appendChild(makeIcon('M6 6l12 12M18 6L6 18'));

	const previousButton = document.createElement('button');
	previousButton.className = 'reference-lightbox__nav reference-lightbox__nav--previous';
	previousButton.type = 'button';
	previousButton.setAttribute('aria-label', 'Pokaż poprzednią referencję');
	previousButton.appendChild(makeIcon('M14 5l-7 7 7 7'));

	const nextButton = document.createElement('button');
	nextButton.className = 'reference-lightbox__nav reference-lightbox__nav--next';
	nextButton.type = 'button';
	nextButton.setAttribute('aria-label', 'Pokaż następną referencję');
	nextButton.appendChild(makeIcon('M10 5l7 7-7 7'));

	const image = document.createElement('img');
	image.className = 'reference-lightbox__image';
	image.alt = '';

	const fullSize = document.createElement('a');
	fullSize.className = 'reference-lightbox__full-size';
	fullSize.textContent = 'Otwórz w pełnym rozmiarze';
	fullSize.target = '_blank';
	fullSize.rel = 'noopener noreferrer';
	fullSize.setAttribute('aria-label', 'Otwórz dokument w pełnym rozmiarze, w nowej karcie');
	lightbox.append(closeButton, previousButton, image, nextButton, fullSize);
	document.body.appendChild(lightbox);

	const updateImage = (index) => {
		const trigger = referenceLinks[index];
		const triggerImage = trigger.querySelector('.references-section__image');
		const imageSrc = trigger.getAttribute('href');

		if (!imageSrc) {
			return;
		}

		activeIndex = index;
		image.src = imageSrc;
		fullSize.href = imageSrc;
		image.alt = triggerImage ? triggerImage.getAttribute('alt') || '' : '';
	};

	const showPrevious = () => {
		const previousIndex = activeIndex === 0 ? referenceLinks.length - 1 : activeIndex - 1;

		updateImage(previousIndex);
	};

	const showNext = () => {
		const nextIndex = activeIndex === referenceLinks.length - 1 ? 0 : activeIndex + 1;

		updateImage(nextIndex);
	};

	const closeLightbox = () => {
		if (!lightbox.classList.contains('is-open')) {
			return;
		}

		lightbox.classList.remove('is-open');
		lightbox.setAttribute('aria-hidden', 'true');
		document.body.classList.remove('reference-lightbox-is-open');
		backgroundStates.forEach((inert, element) => { element.inert = inert; });
		backgroundStates.clear();
		image.removeAttribute('src');
		image.alt = '';

		if (activeTrigger) {
			activeTrigger.focus({ preventScroll: true });
			activeTrigger = null;
		}
	};

	const openLightbox = (trigger) => {
		const triggerIndex = referenceLinks.indexOf(trigger);

		if (triggerIndex < 0) {
			return;
		}

		activeTrigger = trigger;
		updateImage(triggerIndex);
		lightbox.classList.add('is-open');
		lightbox.setAttribute('aria-hidden', 'false');
		document.body.classList.add('reference-lightbox-is-open');
		Array.from(document.body.children).forEach((element) => {
			if (element !== lightbox && !['SCRIPT', 'STYLE', 'LINK'].includes(element.tagName)) {
				backgroundStates.set(element, element.inert);
				element.inert = true;
			}
		});
		closeButton.focus();
	};

	referenceLinks.forEach((link) => {
		link.addEventListener('click', (event) => {
			if (event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
			event.preventDefault();
			openLightbox(link);
		});
	});

	closeButton.addEventListener('click', closeLightbox);
	previousButton.addEventListener('click', showPrevious);
	nextButton.addEventListener('click', showNext);

	lightbox.addEventListener('click', (event) => {
		if (event.target === lightbox) {
			closeLightbox();
		}
	});

	document.addEventListener('keydown', (event) => {
		if (!lightbox.classList.contains('is-open')) {
			return;
		}

		if (event.key === 'Tab') {
			const controls = Array.from(lightbox.querySelectorAll('button, a[href]')).filter((element) => element.getClientRects().length);
			const first = controls[0], last = controls[controls.length - 1];
			if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
			else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
		}
		if (event.key === 'Escape') {
			closeLightbox();
		} else if (event.key === 'ArrowLeft') {
			event.preventDefault();
			showPrevious();
		} else if (event.key === 'ArrowRight') {
			event.preventDefault();
			showNext();
		}
	});

	lightbox.addEventListener(
		'touchstart',
		(event) => {
			canSwipe = event.touches.length === 1 && !event.target.closest('button, a');
			if (!canSwipe) return;
			touchStartX = event.touches[0].clientX;
			touchStartY = event.touches[0].clientY;
		},
		{ passive: true }
	);

	lightbox.addEventListener('touchcancel', () => { canSwipe = false; }, { passive: true });
	lightbox.addEventListener(
		'touchend',
		(event) => {
			if (!canSwipe || event.touches.length) return;
			canSwipe = false;
			const touchEndX = event.changedTouches[0].clientX;
			const verticalDistance = event.changedTouches[0].clientY - touchStartY;
			const touchDistance = touchEndX - touchStartX;

			if (Math.abs(touchDistance) < 48 || Math.abs(touchDistance) <= Math.abs(verticalDistance)) {
				return;
			}

			if (touchDistance > 0) {
				showPrevious();
			} else {
				showNext();
			}
		}
	);
};

export default initReferenceLightbox;
